import { ReactElement } from 'react';

export const Theme = ({ children }: { children: ReactElement }) => (
  <div className="ebds -light-mode">{children}</div>
);
